export default __webpack_public_path__ + "static/media/1.bab60f78.svg";